module.exports = __webpack_public_path__ + "static/media/time-saved.ebd660bf.svg";